export const FETCH_LOCATION_BASED_DUTYTYPE_REQUEST = "FETCH_LOCATION_BASED_DUTYTYPE_REQUEST";
export const FETCH_LOCATION_BASED_DUTYTYPE_SUCCESS = "FETCH_LOCATION_BASED_DUTYTYPE_SUCCESS";
export const FETCH_LOCATION_BASED_DUTYTYPE_FAILURE = "FETCH_LOCATION_BASED_DUTYTYPE_FAILURE";